import { faTimes } from "@fortawesome/pro-light-svg-icons";
import type { JSX } from "react";
import { useTranslation } from "react-i18next";

import { NoStyleButton } from "@aviary/components/Button";
import { Tooltip } from "@aviary/components/Tooltip";
import { l } from "@aviary/locales/i18n";
import { FontAwesomeIcon } from "@shared/react-fontawesome/react-fontawesome";

import * as styles from "./DeprecatedTag.styles";

interface Props {
  /**
   * Text content for the Tag
   *
   * @required
   */
  text: string | JSX.Element;
  /**
   * Callback fired when component is clicked
   */
  handleClick?: () => void;
  /**
   * Specify if label should never truncate
   *
   * @default false
   */
  noEllipses?: boolean;
  /**
   * disables the Tag
   *
   * @default false
   */
  disabled?: boolean;
}

const DeprecatedTag = ({ text, handleClick, noEllipses, disabled = false, ...rest }: Props) => {
  const { t } = useTranslation();

  const tagStyles = [styles.tag, styles.baseSystemProfile, disabled && styles.disabled];
  const labelStyles = [styles.label, noEllipses && styles.noEllipses];
  const showTooltip = typeof text === "string" && text?.length > 18 && !noEllipses;

  return (
    <Tooltip tooltipContent={text} placement="top" isTooltipHidden={!showTooltip}>
      <div css={[tagStyles, styles.baseSystemProfile]} {...rest}>
        <span css={labelStyles}>{text}</span>
        <NoStyleButton
          aria-label={t(l.aviary.tag.remove, { text })}
          onClick={handleClick}
          css={styles.closeButton}
          disabled={disabled}
        >
          <FontAwesomeIcon icon={faTimes} size="xs" />
        </NoStyleButton>
      </div>
    </Tooltip>
  );
};

export { DeprecatedTag };
